<template>
  <div>
    <div class="d-flex mb-2">
      <div class="d-flex align-items-center">
        <OfficeSelect
          ref="OfficeSelect"
          :defaultOfficeId="Number(office_id)"
          :officeList="officeList"
          @officeChange="handleOfficeChange"
        />
        <TeamSelect
          ref="TeamSelect"
          :defaultTeamId="team_id"
          :teamList="teamList"
          @teamChange="handleTeamChange"
        />
      </div>
      <AutoCreateSubHeading
        :step="step"
      />
    </div>
    <AutoCreateNav
      ref="AutoCreateNav"
      :step="step"
      :is_changed="is_changed"
      :year="year"
      :month="month"
      :office_id="officeId"
      :team_id="teamId"
    />
  </div>
</template>
<script>
import AutoCreateNav from '@/Pages/Components/AutoCreateNav';
import AutoCreateSubHeading from '@/Pages/Components/AutoCreateSubHeading';
import OfficeSelect from '@/Pages/Components/OfficeSelect';
import TeamSelect from '@/Pages/Components/TeamSelect';

export default {
  name: 'AutoCreateHeader',
  components: {
    AutoCreateSubHeading,
    AutoCreateNav,
    OfficeSelect,
    TeamSelect,
  },
  props: {
    step: {
      type: Number,
      default: 0,
    },
    is_changed: {
      type: Boolean,
      required: false,
      default: false,
    },
    sort_type: {
      type: Number,
      required: false,
      default: 1,
    },
    office_id: {
      type: String,
      required: false,
      default: '',
    },
    team_id: {
      type: Number,
      required: false,
      default: 0,
    },
    year: {
      type: String,
      required: false,
      default: '',
    },
    month: {
      type: String,
      required: false,
      default: '',
    },
    officeList: {
      type: Array,
      required: false,
      default: () => [],
    },
    teamList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      officeId: this.office_id,
      teamId: this.team_id,
    };
  },
  methods: {
    async handleOfficeChange(newOfficeId) {
      if (this.is_changed  && !(await this.confirmChangeSwal())) {
        return;
      }

      this.officeId = String(newOfficeId);
      this.teamId = 0; // チームをリセット
      
      this.$nextTick(() => {
        this.$refs.AutoCreateNav.go_next_page(this.step);
      });
    },
    async handleTeamChange(newTeamId) {
      if (this.is_changed  && !(await this.confirmChangeSwal())) {
        return;
      }

      this.teamId = newTeamId;
      
      this.$nextTick(() => {
        this.$refs.AutoCreateNav.go_next_page(this.step);
      });
    },
    async confirmChangeSwal() {
      const { isConfirmed } = await this.$swal({
          icon: 'warning',
          title: '変更が破棄されますがよろしいですか？',
          showCancelButton: true,
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          showCloseButton: true,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }); 

      return isConfirmed
    },
    confirm_send(nextStep, message) {
      this.$refs.AutoCreateNav.confirm_send(nextStep, message);
    },
  },
};
</script>
